export const languages = [
  {
    languageText: "English",
    languageCode: "en-US",
  },
  {
    languageText: "Français",
    languageCode: "fr-CA",
  },
];
